import {useState} from 'react';
import {useMsg} from "../hooks/useMsg"
import {tab_color_bg} from "../config/Config"
import {color_note} from "../Fonctions"
import {ModifTitre} from "./ModifTitre"
import {DevoirResend} from "./DevoirResend"


export function Etiquette ({user, auth, devoir, classes, k, updateUsercontext, setShow_activite, setDevoir_cree}) {

 	const cleanDate = (date) => date.slice(-2)+'/'+date.slice(-5,-3)
	const [modifTitre, setModifTitre] = useState({
	 	activ:false,
	 	num:0
	})

	const [copyActiv, setCopyActiv] = useState(false)

	const [resend, setResend] = useState({
	 	activ:false,
	 	num:''
	})

	const {msg, setMsg} = useMsg()

	const sendData = (auth, name) => {
		fetch("https://maths-au-quotidien.fr/react-automaths/api-database.php", {
			  method: 'POST',
			  body: JSON.stringify(auth)
		})
		.then(response => response.json())
		.then(data => {
		  setMsg('La demande de faire ce devoir a bien été supprimée.', 'success', 'fadeout3')
		  updateUsercontext()
		})
		.catch(err => console.log(err))
	}

	const handleSubmit = (e) => {
		const name = e.target.attributes.name.nodeValue
		let confirm = window.confirm("Voulez-vous vraiment supprimer la demande de faire ce devoir ?");
		if (!confirm) {return}
		auth = {...auth, action:name, field:e.target.id}
		sendData(auth, name)
	}

	const moyenne = (eleves) => {
		let moy = 0
		let nb_question = 0
		eleves?.forEach(e => {
		moy = moy + e.note*e.nb_question
		nb_question = nb_question + e.nb_question*1
		})
		return Math.round(moy*10/nb_question)/10
	}

	const menu_options = () =>{
		const result = []

		/*========= oeil =========*/
    result.push(<div className="eye" title="Voir un exemple de devoir aléatoire" onClick={()=>{
			setDevoir_cree({
				notion:devoir.activite.split('__'),
				nb_question:devoir.nb_question,
				etoile:devoir.etoile,
				activite:devoir.activite,
				niveau:devoir.niveau,   				
		    classe:devoir.classe,
		    titre:'',
		    titre_active:false,
		    comm_active:'',
		    listeChoix:devoir.listeChoix,
		    info_diff:false,
		    champ_valid:true,
		    optionnel:'Non',
		    date_limit:'Non',
		    date_limit_value:'',
		    selection:{},
		    search:'',
		    config_supp:'',
		    config_supp_active:false,
		    mode_aleatoire:true,
		    replayable:'∞',
		    nbEssaisMin:1,
		    etape:1,
			})
			setShow_activite(true)
		}} style={{right:'80px'}}>👁</div>)

		/*========= Copier =========*/
		result.push(<div className={copyActiv ? 'copy_themes active' : 'copy_themes'} title='Copier les thèmes de ce devoir' onClick={()=>{
    			navigator.clipboard.writeText(devoir.activite.replaceAll('__', '\u000d'))
    			setCopyActiv(true)
    			setTimeout(() => {
			      setCopyActiv(false);
			    }, 500);
    		}}></div>)

		/*========= Modif Titre =========*/
		result.push(<div className="modif_title_mark" title="Modifier le titre ou la consigne" onClick={()=>{ 
                    setModifTitre({num:k, activ:!modifTitre.activ})
                    setResend({num:k, activ:false})
                  }}>⚙️</div>)

		/*========= Suppr devoir =========*/
		result.push(<div name="suppr_devoir" id={devoir.id} className="suppr_serie" onClick={handleSubmit} title="La suppression de la demande de faire ce devoir ne supprimera pas les résultats de ce devoir." ></div>)

		/*========= Resend devoir =========*/
		result.push(<div className="resend_mark" title="Renvoyer le devoir à une autre classe" onClick={()=>{
		    setResend({num:k, activ:!resend.activ})
		    setModifTitre({num:k, activ:false})
		  }
		}>↪</div>)

		return result
	}


	//console.log('devoir : ' ,devoir)
	//console.log('classes : ' ,classes)
  return (
  	<>
    {msg ? <div dangerouslySetInnerHTML={{ __html:msg}}></div> : ''}
    <div className="message resultat" title={devoir.activite.replaceAll('__', '\u000d')} style={{backgroundColor:tab_color_bg[classes.indexOf(devoir.classe, 0)], maxHeight:'800px'}} >

    	<div className="info_mess">{devoir.donne_le}<br/>{!devoir.date_limit.includes('0000') ? <span className="date_limit_arrow">{cleanDate(devoir.date_limit)}</span>:''}</div>
    	{devoir.facultatif === '1' ? <div className="facultatif_mark" title="Devoir optionnel"></div> : ''}
    	{devoir.listeChoix ? <div className="choisi_mark" title="Devoir dont les questions sont choisies"></div> : ''}

    	{menu_options()}
    	
		<div className="note_serie">{devoir.classe}</div> <div className="nb_question">{devoir.listeChoix ? devoir.listeChoix.split('_').length : devoir.nb_question}Q</div> {devoir.etoile === '4' ? <span style={{color:"steelblue", fontWeight:"bold"}} >🅳</span> : '⭐'.repeat(devoir.etoile)}{devoir.nbEssaisMin*1 > 1 && <span style={{color:'grey'}}>({devoir.nbEssaisMin} essais min)</span>}
		{devoir.replayable === '0' ? <span style={{color:'grey'}}>(Un seul essai)</span> :''}
		<div>{devoir.title || devoir.activite.split('__')[0] + (devoir.activite.split('__')[1] ? '...' : '')}</div>
		{devoir.consigne && <div className="consigne">{devoir.consigne}</div>}
		{
			(modifTitre.activ && modifTitre.num === k) ? <ModifTitre auth={{...auth, field_title:devoir.activite}} updateUsercontext={updateUsercontext} action={()=>setModifTitre({num:'', activ:''})} title={devoir.title} consigne={devoir.consigne} />
			: ''
		}

		{user.activite_faites[devoir.classe][devoir.activite] ? 
		<span>
		  <span className="green">{user.activite_faites[devoir.classe][devoir.activite]?.length}/{user.mes_classes[devoir.classe]?.length}</span> - <span className={color_note(moyenne(user.activite_faites[devoir.classe][devoir.activite]))}>{moyenne(user.activite_faites[devoir.classe][devoir.activite])}%</span>
		</span>:''
		}
		{
		(resend.activ && resend.num === k) ? <DevoirResend auth={{...auth, classes:user.liste_classes.filter(e=>e!==devoir.classe)}} devoir={devoir} updateUsercontext={updateUsercontext} action={()=>setResend({num:'', activ:false})}  />
		: ''
		}
    </div>
    </>
  );
}